import { createSelector } from './selectorWrapper'
import { simpleSelectors} from './basicState'
import { isStarlightEnhancedSelector } from './shared'
import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { GetStaticPageContentResponse } from '@amzn/pv-starlight-presentation-service-lambda-typescript-client'
import { pageFeaturesSelector } from './pageContext'

export const showExploreTabSelector = createSelector(
  [isStarlightEnhancedSelector, pageFeaturesSelector, simpleSelectors.exploreTabContent],
  (isStarlight: boolean, features: WpsTypes.atv.wps.FeatureMap, response?: GetStaticPageContentResponse) =>
    features['disableExploreTab'] !== 'true' && Boolean(isStarlight && response && response.staticPageContent)
)
